// extracted by mini-css-extract-plugin
export default {"eventsContainer":"TeamProfileEventsPage_eventsContainer__mRCiD"};